module.exports = __webpack_public_path__ + "static/img/default_img_nofind.6b6bdfed.png";